import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ExperiencesService } from "@services/experience/experiences.service";
import { ErrorEmitterService } from "@services/emitters/error-emitter.service";
import { Router } from "@angular/router";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppConfigService } from "@services/config.service";
declare const FB: any;
@Component({
  selector: "app-import-experiences",
  templateUrl: "./import-experiences.component.html",
  styleUrls: ["./import-experiences.component.scss"],
})
export class ImportExperiencesComponent implements OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  public fbToken: string;
  public experiences: Array<any>;
  public loader: boolean = false;
  public noRecords: boolean = false;
  public facebookKey: any;
  constructor(
    private experienceSvc: ExperiencesService,
    private errorEmitter: ErrorEmitterService,
    private router: Router,
    private config: AppConfigService,
    private cRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    let that = this;
    this.facebookKey = this.config.get((x) => x.keys_apis.facebookKey);
    (window as any).fbAsyncInit = function () {
      FB.init({
        appId: that.facebookKey,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v5.0",
      });
      FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    this.getFbExperiences();
  }

  public login() {
    let that = this;
    FB.login(function (response) {
      if (response.authResponse) {
        that.fbToken = response.authResponse.accessToken;
        that.setToken(that.fbToken);
      } else {
        that.errorEmitter.sendError(true);
      }
    });
  }

  public getFbExperiences() {
    this.noRecords = false;
    this.experienceSvc
      .getFbExperiences()

      .subscribe(
        (x) => {
          if (x.result.events.length === 0) {
            this.noRecords = true;
          } else {
            this.experiences = x.result.events;
            this.cRef.detectChanges();
          }
        },
        (err) => {
          if (!this.fbToken) {
            this.login();
          }
        }
      );
  }

  public setToken(id: string) {
    this.experienceSvc
      .setFbToken(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((x) => {
        this.getFbExperiences();
      });
  }

  public importFbExperience(id: string) {
    this.loader = true;
    this.experienceSvc
      .importFbExperience(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((x) => {
        this.router.navigate(["create-experience", x.result.id]);
        this.loader = false;
      });
  }

  public createExperience() {
    this.loader = true;
    this.experienceSvc
      .createExperience()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (x) => {
          this.router.navigate(["create-experience", x.result.id]);
          this.loader = true;
        },
        (err) => {
          this.errorEmitter.sendError(true);
        }
      );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
